import Hero from '../components/sections/Hero';
import BlogCarousel from '../components/sections/BlogCarousel';
import LandscapeAxesGrid from '../components/sections/LandscapeAxesGrid';
import ImpactGBS from '../components/sections/ImpactGBS';
import ModernSwissAvengers from '../components/sections/ModernSwissAvengers';
import ProofBar from '../components/sections/ProofBar';

const Home = () => {
  return (
    <main className="relative pt-[48px]" style={{
      minHeight: '100vh',
      background: 'url(/images/meet-background.png) center/cover no-repeat fixed'
    }}>
      {/* 1) Carrousel d'articles de blog en bannière ultra-compacte */}
      <section id="blog-carousel">
        <BlogCarousel />
      </section>

      {/* 2) Section Hero - Agentic R&D, Local-First */}
      <section id="hero">
        <Hero />
      </section>

      {/* 3) Landscape Axes Grid - 7 axes stratégiques */}
      <section id="landscape">
        <LandscapeAxesGrid />
      </section>

      {/* 4) Impact GBS - Initiative 100k CHF */}
      <section id="impact">
        <ImpactGBS />
      </section>

      {/* 5) Swiss Avengers - IMPORTANT: Ne jamais supprimer */}
      <section id="swiss-avengers" className="py-4">
        <ModernSwissAvengers />
      </section>

      {/* 6) Proof Bar - 4 badges de confiance */}
      <section id="proof">
        <ProofBar />
      </section>
    </main>
  );
};

export default Home; 